import apiService from './api/api.service';
import { logger } from '@utils/logger';

class FeedbackService {
  async checkEligibility() {
    try {
      const response = await apiService.get('/feedback/eligibility');
      return response;
    } catch (error) {
      logger.error('Error checking feedback eligibility', error);
      throw error;
    }
  }

  async recordShown() {
    try {
      const response = await apiService.post('/feedback/shown');
      return response;
    } catch (error) {
      logger.error('Error recording feedback shown', error);
      throw error;
    }
  }

  async recordDismissed() {
    try {
      const response = await apiService.post('/feedback/dismissed');
      return response;
    } catch (error) {
      logger.error('Error recording feedback dismissed', error);
      throw error;
    }
  }

  async submitFeedback(feedbackData) {
    try {
      const response = await apiService.post('/feedback/submit', feedbackData);
      return response;
    } catch (error) {
      logger.error('Error submitting feedback', error);
      throw error;
    }
  }

  async getAllFeedback(filters = {}) {
    try {
      const response = await apiService.get('/feedback/all', { params: filters });
      return response;
    } catch (error) {
      logger.error('Error fetching all feedback', error);
      throw error;
    }
  }

  async updateReview(feedbackId, reviewData) {
    try {
      const response = await apiService.put(`/feedback/${feedbackId}/review`, reviewData);
      return response;
    } catch (error) {
      logger.error('Error updating feedback review', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await apiService.get('/feedback/stats');
      return response;
    } catch (error) {
      logger.error('Error fetching feedback stats', error);
      throw error;
    }
  }
}

export default new FeedbackService();
